/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
import React, { useState, useEffect } from 'react';

import { useParams } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, Modal, ModalBody,
  ModalHeader, ModalFooter, Button, Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';

import {
  Table, Tbody, Tr, Th, Td, Thead,
} from 'react-super-responsive-table';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import classnames from 'classnames';
import FamilyForm from '../../components/Fuse/FamilyForm';
import { Can } from '../../utilities/Can';
import { del, get, put } from '../../helpers/api_helper';

import BaseGrid from '../../components/Common/BaseGrid';

import 'react-querybuilder/dist/query-builder.css';

function FuseFamily(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const { id } = useParams();
  const [editModal, setEditModal] = useState(false);
  const [entity, setEntity] = useState(null);
  const [signal, setSignal] = useState(1);
  const [activeTab, setActiveTab] = useState('99');

  const origFields = [
    { name: 'manufacturer', label: 'Manufacturer', operators: ['contains', 'does not contain'] },
    { name: 'part_number', label: 'Part Number', operators: ['contains', 'does not contain'] },
  ];

  const getEntity = async () => {
    try {
      const ent = await get(`/api/fuse/family/${id}`);
      setEntity(ent);
    } catch (error) {
      toastr.error(error.message, t('Error'));
    }
  };

  const toggle = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    getEntity();
  }, [id, signal]);

  const deleteFamily = async () => {
    try {
      if (entity && confirm(t('Are you sure?'))) {
        await del(`/api/fuse/family/${entity.id}`);

        setSignal(signal + 1);
        toastr.success(`${entity.name} deleted!`, t('Success'));
      }
    } catch (error) {
      toastr.error(error.message, t('Error while deleting'));
    }
  };

  const index = async () => {
    try {
      await get(`/api/fuse/family/${id}/index`);

      toastr.success('Successfully reindexed items');
      setSignal(signal + 1);
    } catch (error) {
      toastr.error(error.message);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="5">
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                {entity && entity.name}
              </CardHeader>
              <CardBody>
                <Can i="see" this="Fuse">
                  <div className="table-responsive">
                    <Table className="table table-bordered">
                      <Tbody>
                        <Tr>
                          <Th>{t('Name')}</Th>
                          <Td>{entity ? entity.name : '--'}</Td>
                        </Tr>
                        <Tr>
                          <Th>{t('Derived Qty')}</Th>
                          <Td>{entity ? entity.qty : '--'}</Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </div>

                  <div className="hstack gap-2">
                    <Button color="primary" size="sm" className="btn-soft-primary" onClick={() => { setEditModal(true); }}>
                      <span className="mdi mdi-pencil" />
                      {' '}
                      {t('Edit')}
                    </Button>
                    <Button color="danger" size="sm" className="btn-soft-danger" onClick={deleteFamily}>
                      <span className="mdi mdi-close-thick" />
                      {' '}
                      {t('Delete')}
                    </Button>

                    <Button color="default" size="sm" className="border" onClick={index}>
                      <span className="mdi mdi-refresh" />
                      {' '}
                      {t('Index Items')}
                    </Button>
                  </div>
                </Can>

                <Can not i="see" this="Fuse"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>

            <Card>
              <CardBody>
                <Can i="see" this="Fuse">
                  <div className="table-responsive">
                    <Table className="table table-bordered">
                      <Thead>
                        <Tr>
                          <Th>{t('Component')}</Th>
                          <Th>{t('Indexed Items Count')}</Th>
                          <Th>{t('Static Qty')}</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {entity && entity.components.filter((x) => ['any', 'component'].includes(x.scope)).map((x) => (
                          <Tr>
                            <Td>{x.description}</Td>
                            <Td style={{ minWidth: '100px' }}>{x.indexed_items.length}</Td>
                            <Td style={{ minWidth: '100px' }}>{x.indexed_items.reduce((a, c) => a + c.stock.reduce((aa, cc) => aa + cc.qty, 0), 0)}</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </div>
                </Can>
              </CardBody>
            </Card>
          </Col>

          <Col xxl="7">
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: 'pointer' }}
                  className={classnames({
                    active: (activeTab === '99'),
                  })}
                  onClick={() => {
                    toggle('99');
                  }}
                >
                  {t('Listings')}
                </NavLink>
              </NavItem>
              {entity && entity.components.filter((x) => ['any', 'component'].includes(x.scope)).map((x, i) => (
                <NavItem>
                  <NavLink
                    style={{ cursor: 'pointer' }}
                    className={classnames({
                      active: (activeTab === i.toString()),
                    })}
                    onClick={() => {
                      toggle(i.toString());
                    }}
                  >
                    {x.description}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>

            <TabContent activeTab={activeTab}>
              <TabPane key="chn_tab_99" tabId="99">
                <Card>
                  <CardBody>
                    <Can i="see" this="Fuse">
                      {entity && (
                        <BaseGrid
                          url={`/api/fuse/family/${entity.id}/listings`}
                          shouldUpdate={signal}
                          className="table table-sm fs-6 table-nowrap table-hover table-bordered"
                          hasSearch
                          config={
                          {
                            columns: {
                              thumb: {
                                label: '',
                                image: {
                                  src: (lst) => (`/api/listings/thumbnail/${lst.id}`),
                                  class: 'rounded',
                                  style: { maxHeight: '3rem', maxWidth: '3rem' },
                                },
                                translate: false,
                              },
                              id: {
                                label: props.t('ID'),
                                sort: true,
                                link: {
                                  to: '/listing/%id%',
                                },
                              },
                              sku: {
                                label: props.t('Sku'),
                                sort: true,
                                link: {
                                  to: '/listing/%id%',
                                },
                              },
                              title: {
                                label: props.t('Title'),
                              },
                            },
                            pagination: {
                              sort: 'id',
                              direction: 'desc',
                              perPage: 10,
                            },
                          }
                          }
                        />
                      )}
                    </Can>
                  </CardBody>
                </Card>
              </TabPane>
              {entity && entity.components.filter((x) => ['any', 'component'].includes(x.scope)).map((x, i) => (
                <TabPane key={`chn_tab_${x.id}`} tabId={i.toString()}>
                  <Card>
                    <CardBody>
                      <Can i="see" this="Fuse">
                        <BaseGrid
                          url={`/api/fuse/family/component/${x.id}/items`}
                          shouldUpdate={signal}
                          className="table table-sm fs-6 table-nowrap table-hover table-bordered"
                          hasSearch
                          config={
                          {
                            columns: {
                              thumb: {
                                label: '',
                                image: {
                                  src: (item) => (`/api/items/thumbnail/${item.id}`),
                                  class: 'rounded',
                                  style: { maxHeight: '3rem', maxWidth: '3rem' },
                                },
                                translate: false,
                              },
                              id: {
                                label: props.t('ID'),
                                sort: true,
                                link: {
                                  to: '/item/%id%',
                                },
                              },
                              manufacturer: {
                                label: props.t('Manufacturer'),
                                sort: true,
                              },
                              part_number: {
                                label: props.t('Part Number'),
                                sort: true,
                                link: {
                                  to: '/item/%id%',
                                },
                              },
                              stock: {
                                label: props.t('Static Qty'),
                                format: (f) => (f.reduce((a, c) => a + c.qty, 0)),
                              },
                            },
                            pagination: {
                              sort: 'static_qty',
                              direction: 'desc',
                              perPage: 10,
                            },
                          }
                          }
                        />
                      </Can>
                    </CardBody>
                  </Card>
                </TabPane>
              ))}
            </TabContent>
          </Col>
        </Row>

        <Modal isOpen={editModal} size="lg">
          <ModalHeader>
            {t('Edit Family')}
          </ModalHeader>
          <ModalBody>
            {entity && (
              <FamilyForm
                entity={entity}
                onSuccess={() => { setSignal(signal + 1); setEditModal(false); }}
              />
            )}

            {!entity && (
              <FamilyForm
                onSuccess={() => { setSignal(signal + 1); setEditModal(false); }}
              />
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="link" onClick={() => { setEditModal(false); }}>
              {t('Cancel')}
            </Button>

            <Button type="submit" form="FuseFamilyForm">{entity ? t('Update') : t('Create')}</Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

FuseFamily.defaultProps = {
  t: (x) => (x),
};

FuseFamily.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(FuseFamily));
